export function getScreenshotScale(
  viewportWidth: number,
  maxWidth: number
): number {
  if (viewportWidth <= 0) {
    return 1;
  }
  return Math.min(1, maxWidth / viewportWidth);
}
